import React from "react"

import {MenuOption, PopoverMenuItemType} from "../../../../gd-components/popover-menu/popover-menu/const"
import {TaskAction} from "../@const"
import Task from "../../../../model2/task/task"
import StatusIcon from "../components/status-icon"
import TaskMoreMenuStatus from "../../../select-status/task_v2/render/more-menu-status"
import TaskStatusManager from "../../../../gd/manager/task-status-manager"

export type Props = {
    task                : Task

    hiddenActions?      : TaskAction[],
    disabledActions?    : string[],

    hidePopover?        : callback
}

export function taskMore_initChangeStatus(props: Props, menuOptions:MenuOption[]) {

    const task = props.task

    if (props.hiddenActions?.includes(TaskAction.UPDATE_STATUS)) {
        return
    }

    const currentStatus = gd.session.statuses.get(task.statusId)

    const canChangeStatus = task.acl.canChangeStatus
    menuOptions.push({
        type                : PopoverMenuItemType.CUSTOM_POPOVER,
        iconComponent       : (
            <StatusIcon
                className       = {Classes("ico", {
                    'is-disabled': !canChangeStatus
                })}
                currentStatus   = {currentStatus}
            />
        ),
        label               : 'Update Status',
        menuComponent       : TaskMoreMenuStatus,
        menuParams          : {
            task                : props.task,
            workflow            : TaskStatusManager.getWorkflow(task),
            hint                : true,
            classes             : "min-w-200",
            togglePopover       : props.hidePopover
        },
        disabled            : !canChangeStatus,
    })

}